import { Column } from '~components/table-view';

export const columns: Column[] = [
  {
    id: 'id',
    header: '<itemId>',
    type: 'text',
  },
  {
    id: 'ref',
    header: '<invoiceItemExternalReferenceItemId>',
    type: 'text',
  },
  {
    id: 'reason',
    header: 'Reason',
    type: 'text',
  },
  {
    id: 'details',
    header: 'Details',
    type: 'text',
  },
];
